import { Button, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useProduct } from "src/context/ProductProvider";
import { useIsMobile } from "src/hooks/useIsMobile";
import Carousel from "src/shared/components/Carousel";
import { berforeAfters } from "src/constants/beforeAndAfters";
import BeforeAfterCard from "./components/BeforeAfterCard";

interface Props {
  onNavigate: () => void;
}

const HairLossBeforeAfter = ({ onNavigate }: Props) => {
  const isMobile = useIsMobile();
  const productSlug = useProduct((p) => p.slug);
  const { t } = useTranslation();
  const page = "welcome-2";

  const title = useMemo(() => {
    if (productSlug != null) {
      return t(
        `${page}.${productSlug}.title`,
        "Thicker, fuller hair is closer than you think. Results in just 3 to 6 months."
      );
    }

    return "";
  }, [productSlug, t]);

  return (
    <Stack gap={2} p={1}>
      <Stack gap={2}>
        <Typography variant={isMobile ? "h6" : "h4"} fontWeight={600}>
          {title}
        </Typography>
      </Stack>
      <Carousel length={berforeAfters.length}>
        {berforeAfters.map((card) => (
          <BeforeAfterCard
            card={card}
            key={card.id}
            width="100%"
            onNext={onNavigate}
          />
        ))}
      </Carousel>
      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 3 }}
        onClick={onNavigate}
        disabled={!productSlug}
      >
        {t("button.next")}
      </Button>
    </Stack>
  );
};

export default HairLossBeforeAfter;
